import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../components/Modal';
import FirstStep from './FirstStep';
import Alert from '../../../components/Alert';
import { fetchColoresGet,fetchUsoGet,savePedidoColor,savePedidoUso,deletePedidoUso} from '../../../actions';

const IND_COLOR_FAB = 'N';
const IND_INACTIVO = 'N';

class AplicarColorUso extends Component {
  constructor(props) {

    super(props);
    this.state = {
      muestraMensaje: false,
      pedidos:props.pedidos,
      idUso:props.pedidosColorUsoIdUso,
      colores:props.pedidosColorUsoColores===''?[{'id':1,'idColor':''}]:props.pedidosColorUsoColores.map((color,i) =>({'id':(i+1),'idColor':color}) ),
      ordersColorsList:this.props.ordersColorsList.map(entry => {
        return Object.assign(
          {},entry,{codAVtaFamUso:this.props.allUseOrdersFV.filter(element => element.numPedidoVeh===entry.numPedidoVeh).length>0?this.props.allUseOrdersFV.filter(element => element.numPedidoVeh===entry.numPedidoVeh)[0].codAvtaFamUso:this.props.proforma.codAVtaFamUso,desUsoVeh:this.props.proforma.desUsoVeh}
        )
      }),
      ordersColorsRemoved:[],
      allUseProformaFV:[],
      allDeletePedidos:[]
    }

  }

  fnSavePedidosColorUso = () => {

    this.props.loading('block');
    const promises = [];

    this.state.ordersColorsList.filter(entry => this.props.pedidosConCheck.indexOf(entry.numPedidoVeh)>=0)
    .forEach(pedido => {
      let arrayObjetosDeColores = [];
      let descAVtaFamUso = this.props.usos.filter(uso => uso.codAVtaFamUso===pedido.codAVtaFamUso);
      descAVtaFamUso = descAVtaFamUso.length>0?descAVtaFamUso[0].desUsoVeh:null;

      pedido.orderColors.forEach((color, index) =>{

        arrayObjetosDeColores.push({
          nurFichaVtaPedido:pedido.nurFichaVtaPedido,
          numColorFabricaVeh:color.numColfabVeh,
          codColorFabricaVeh:color.codColorFabricaVeh,
          indColorFab:IND_COLOR_FAB,
          indInactivo:IND_INACTIVO,
          numPedidoVeh:pedido.numPedidoVeh,
          desColorFabricaVeh:color.desColorFabricaVeh
        });
      })
      promises.push(this.props.savePedidoColor(this.props.idFichaVenta,arrayObjetosDeColores));
      promises.push(this.props.savePedidoUso(this.props.idFichaVenta,pedido.numPedidoVeh,pedido.codAVtaFamUso,pedido.nurFichaVtaPedido,pedido.numPedidoVeh,descAVtaFamUso));

    });

    this.state.ordersColorsRemoved.filter(entry => entry.numColfabVeh!==undefined).forEach(entry => {
      promises.push(this.props.deletePedidoUso(this.props.idFichaVenta,entry.numPedidoVeh,entry.numColfabVeh));
    })

    Promise.all(promises)
    .then((results) => {
      this.props.loading('');
      this.props.openAlert({ estadoTrama: '1', mensaje: 'Se registraron los cambios correctamente.' });
      this.props.closeModal();
      this.props.traerColorUso();
      this.props.changeIndex(this.props.activeFilterPedido);


    });

  }

  componentDidMount() {

    if(this.props.pedidosColorUsoVieneDe === 'pedido'){
      this.setState({muestraMensaje:this.props.pedidosColorUsoTieneColorUsoDistintos});
    }
    this.props.fetchColoresGet(this.props.codAreaVta,this.props.codFamiliaVeh,this.props.codMarca);
    this.props.fetchUsoGet(this.props.codAreaVta,this.props.codFamiliaVeh);
    /*
    if (this.props.codFamiliaVeh === "1") {
      this.props.openAlert({ estadoTrama: '0', mensaje: 'Para automoviles no es validad esta accion.' });
      this.props.closeModal();
    }*/


  }
  traerColor = (colores,id) => {
    const color = colores.find(color=>color.codPintura===id);
    return color===undefined?'':`${color.codPintura}-${color.color}-${color.colorSunarp}-${color.codColorSunarp}`;
  }
  changeOptionColor = (event,idState, numPedidoVeh,id) => {
    let ordersColorsList = this.state.ordersColorsList;
    ordersColorsList.forEach(entry => {
      if(entry.numPedidoVeh===numPedidoVeh){

        entry.orderColors.forEach(entryColores => {
          if(entryColores.id===id){
            entryColores.codColorFabricaVeh=event.target.value.split('-')[0]
            entryColores.desColorFabricaVeh=event.target.value.split('-')[1]
          }
        })
      }
    })

    this.setState({ordersColorsList: ordersColorsList});
  }
  clickAgregarColor = (numPedidoVeh) =>{
    let orderColors = this.state.ordersColorsList.filter(entry => entry.numPedidoVeh===numPedidoVeh)[0];
    orderColors.orderColors = [...orderColors.orderColors,{codColorFabricaVeh:'',id: orderColors.orderColors.length>0?Math.max(...orderColors.orderColors.map(entry => {return entry.id}))+1:0}]
    let ordersColorsList = [...this.state.ordersColorsList.filter(entry => entry.numPedidoVeh!==numPedidoVeh),orderColors];

    ordersColorsList=this.fnOrder(ordersColorsList);
    this.setState({ordersColorsList:ordersColorsList});



  }

  fnOrder = (ordersColorsList) => {
    return ordersColorsList.sort(function(a, b) {
          if (a.numPedidoVeh > b.numPedidoVeh) {
            return 1;
          }
          if (a.numPedidoVeh < b.numPedidoVeh) {
            return -1;
          }
          return 0;
        });
  }


  clickQuitarColor = (e, codColorFabricaVeh,numPedidoVeh) =>{

    let ordersColorsList = this.state.ordersColorsList;
    let orderColors = [];
    ordersColorsList.forEach(entry => {
      if(entry.numPedidoVeh===numPedidoVeh){
        orderColors=entry.orderColors.filter(entryColores => entryColores.codColorFabricaVeh===codColorFabricaVeh)[0]
        entry.orderColors=entry.orderColors.filter(entryColores => entryColores.codColorFabricaVeh!==codColorFabricaVeh)
      }

      this.setState({ordersColorsRemoved:[...this.state.ordersColorsRemoved,Object.assign({},orderColors,{numPedidoVeh:numPedidoVeh})]})

    })

    this.setState({ordersColorsList: ordersColorsList})
  }
  clickQuitarPedido = (e,numPedidoVeh) =>{
    this.setState({ ordersColorsList: this.state.ordersColorsList.filter(pedido => pedido.numPedidoVeh!==numPedidoVeh)   });
  }
  changeOptionUso = (event,numPedidoVeh) => {

    let orderColors = this.state.ordersColorsList.filter(entry => entry.numPedidoVeh===numPedidoVeh)[0];
    orderColors.codAVtaFamUso = event.target.value.split('-')[0];
    orderColors.descAVtaFamUso = event.target.value.split('-')[1];
    let ordersColorsList = [...this.state.ordersColorsList.filter(entry => entry.numPedidoVeh!==numPedidoVeh),orderColors];
    ordersColorsList=this.fnOrder(ordersColorsList);

    this.setState({ordersColorsList:ordersColorsList});
  }
  traerUso = (usos,id) =>{
    const uso = usos.find(us=>us.codAVtaFamUso===String(id));
    return uso===undefined?'':`${uso.codAVtaFamUso}-${uso.desUsoVeh}`;
  }


  closeAlertError = ()  =>{
    this.setState({muestraMensaje: false});
  }
  render() {
    const { colores,usos } = this.props;
    if (!colores || !usos) return null;
    return (
      <Modal title='Aplicar color y uso' idModal='color-uso' isOpen closeModal={this.props.closeModal} modalSize='modal-dialog'>
        <FirstStep
          colores={this.props.colores}
          usos={this.props.usos}
          changeOptionColor={this.changeOptionColor}
          traerColor={this.traerColor}
          clickAgregarColor={this.clickAgregarColor}
          clickQuitarColor={this.clickQuitarColor}
          clickQuitarPedido={this.clickQuitarPedido}
          changeOptionUso={this.changeOptionUso}
          traerUso={this.traerUso}
          fnSavePedidosColorUso={this.fnSavePedidosColorUso}
          coloresDePedidosList={this.state.ordersColorsList}
          pedidosConCheck={this.props.pedidosConCheck}
          closeModal={this.props.closeModal}
          codFamiliaVeh={this.props.codFamiliaVeh}          
        />
        {
          this.state.muestraMensaje &&
          <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError }>
            <p>Los pedidos seleccionados tiene diferentes uso y color</p>
          </Alert>
        }

      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return { colores:state.colores,usos:state.usos,
  };
}

export default connect(
  mapStateToProps,
  {fetchColoresGet,fetchUsoGet,savePedidoColor,savePedidoUso,deletePedidoUso }

)(AplicarColorUso);



// WEBPACK FOOTER //
// ./src/pages/modals/AplicarColorUso/index.js